const safePause = (el) => {
	try {
		el && el.pause();
	} catch (_) {}
};

const resetLater = (el) => {
	setTimeout(() => {
		try {
			if (el) el.currentTime = 0;
		} catch (_) {}
	}, 0);
};


export default function playPause(target, pool = {}, errorPlay) {
	if (!target) return;

	// Toggle OFF
	if (!target.paused && !target.ended) {
		safePause(target);
		resetLater(target);
		return;
	}

	try {
		Object.keys(pool || {}).forEach((k) => {
			const el = pool[k];
			if (!el || el === target) return;
			if (!el.paused) safePause(el);
			resetLater(el);
		});
	} catch (_) {}


	Promise.resolve().then(() => {
		const p = target.play();
		if (p && typeof p.catch === 'function') {
			p.catch((err) => {
			if (err && (err.name === 'AbortError' || err.code === 20))
					return;
				if (typeof onErrorPlay === 'function') errorPlay();
				else console.log('play() failed', err);
			});
		}
	});
}
